// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__yKU_2","inner":"Footer_inner__24tU3","nextIcon":"Footer_nextIcon__2LLCu","innerLeft":"Footer_innerLeft__2xYnB"};